export default __webpack_public_path__ + "static/media/gutschein_kino_glueckliche_besucher.4d5250fd.jpg";